/**
 * Shared cookie options for Supabase auth tokens across the browser
 * client, server client and middleware refresh path.
 *
 * Without explicit maxAge the @supabase/ssr lib writes session cookies
 * that get cleared whenever the browser/PWA process is killed — iOS
 * Safari ITP plus iPadOS PWA backgrounding caused Verde Cafe to be
 * logged out repeatedly. A 30-day max-age keeps the refresh token
 * cookie persistent across launches; supabase-js still rotates the
 * access token automatically via getUser() / refreshSession() within.
 *
 * secure is keyed on NODE_ENV so local dev over http://localhost still
 * works while production rezaro.de always sets the Secure flag (an
 * extra ITP requirement on iOS).
 */
export const SUPABASE_COOKIE_OPTIONS = {
  maxAge: 60 * 60 * 24 * 30, // 30 days in seconds
  sameSite: 'lax' as const,
  path: '/',
  secure: process.env.NODE_ENV === 'production',
}
